module.exports = __webpack_public_path__ + "static/img/11i.f7564b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11i.jpg
// module id = 5G1M
// module chunks = 1